export default __webpack_public_path__ + "static/media/frasco41.15f85957.png";